import * as React from "react";
import "./styles.scss";
import { PAYMENT_PLANS } from "../../generated/lib-domain/paymentPlan";
import {
    PaymentMethodEnum,
    SubscriptionEnum
} from "../../generated/UserAPIAgent";

interface PriceDifferenceProps {
    subscription: SubscriptionEnum;
    addText: boolean;
    isNotPaidMember: boolean;
}
const PriceDifference = (props: PriceDifferenceProps): JSX.Element => {
    const priceDifferenceBetweenIapAndCredit =
        PAYMENT_PLANS.find(
            (plan) =>
                plan.subscription === props.subscription &&
                plan.paymentMethod === PaymentMethodEnum.ios_iap
        ).amount -
        PAYMENT_PLANS.find(
            (plan) =>
                plan.subscription === props.subscription &&
                plan.paymentMethod === PaymentMethodEnum.credit_card
        ).amount;
    if (props.isNotPaidMember && priceDifferenceBetweenIapAndCredit > 0) {
        return (
            <section className="confirm-payment">
                <div className="current-payment-method">
                    <p className="not-paid-member-label text-center">
                        Apple決済より毎月最大
                        <br />
                        <span className="discount">
                            {priceDifferenceBetweenIapAndCredit.toLocaleString(
                                "ja-JP"
                            )}
                            円
                        </span>
                        お得！
                    </p>
                </div>
            </section>
        );
    }
    if (props.addText && priceDifferenceBetweenIapAndCredit > 0) {
        return (
            <div className="payment-make-lead-message">
                以下のボタンよりクレジットカード
                <br />
                決済に変更すると…
                <br />
                <p className="not-paid-member-label">
                    Apple決済より
                    <span className="discount">
                        {priceDifferenceBetweenIapAndCredit.toLocaleString(
                            "ja-JP"
                        )}
                        円
                    </span>
                    お得！
                </p>
            </div>
        );
    }
    if (priceDifferenceBetweenIapAndCredit > 0) {
        return (
            priceDifferenceBetweenIapAndCredit > 0 && (
                <p className="not-paid-member-label">
                    Apple決済より
                    <span className="discount">
                        {priceDifferenceBetweenIapAndCredit.toLocaleString(
                            "ja-JP"
                        )}
                        円
                    </span>
                    お得！
                </p>
            )
        );
    } else {
        return <></>;
    }
};

export default PriceDifference;
